/* eslint-disable prettier/prettier */
<template>
  <button
    class="btn mb-0"
    :class="getClasses(variant, color, size, fullWidth, active, loading)"
  >
    <slot v-if="!loading" />
    <div v-if="loading">
      <span>{{ isLoadingText }}</span>
      <div class="spinner-border spinner-border-sm ms-2" />
    </div>
  </button>
</template>


<script>
import { toRef } from "vue";
export default {
  name: "argon-button",
  props: {
    color: {
      type: String,
      default: "info",
    },
    size: {
      type: String,
      default: "md",
    },
    variant: {
      type: String,
      default: "fill",
    },
    fullWidth: {
      type: Boolean,
      default: false,
    },
    active: {
      type: Boolean,
      default: false,
    },
    isLoading: {
      type: Boolean,
      default: false,
    },
    isLoadingText: {
      type: String,
      default: "Loading...",
    },
  },
  methods: {
    getClasses: (variant, color, size, fullWidth, active, isLoading) => {
      let colorValue, sizeValue, fullWidthValue, activeValue, disable;

      // Setting the button variant and color
      if (variant === "gradient") {
        colorValue = `bg-gradient-${color}`;
      } else if (variant === "outline") {
        colorValue = `btn-outline-${color}`;
      } else {
        colorValue = `btn-${color}`;
      }

      sizeValue = size ? `btn-${size}` : '';

      fullWidthValue = fullWidth ? `w-100` : '';

      activeValue = active ? `active` : '';

      disable = isLoading ? "disabled" : '';

      return `${colorValue} ${sizeValue} ${fullWidthValue} ${activeValue} ${disable} `;
    },
  },
  setup(props) {
    const loading = toRef(props, "isLoading");
    return { loading };
  },
};
</script>
